module.exports = __webpack_public_path__ + "media/images/pages/bg_area_10-8f01b57b0f937a778465a90752138a18.png";